import { SingleFeedback } from "./SingleFeedback";
import { MultipleFeedback } from "./MultipleFeedback";
import { FeedbackHeader } from "./FeedbackHeader";
import {AddInfoFeedback} from "./AddInfoFeedback"
import {FeedbackThankyou} from './FeedbackThankyou'
import {FeedbackHero} from './FeedbackHero'
import {FeedbackNavigation} from './FeedbackNavigation'
import {FeedbackFormPreview} from "./FeedbackFormPreview"
import {FeedbackReviewPreview} from './FeedbackReviewPreview'

export {SingleFeedback, MultipleFeedback, FeedbackHeader, AddInfoFeedback, FeedbackThankyou, FeedbackHero, FeedbackNavigation, FeedbackFormPreview,
  FeedbackReviewPreview
}